/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForKubernetesClusterAws extends models.ServiceAccountCredentialsBaseForKubernetesCluster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForKubernetesClusterAws");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForKubernetesClusterAws.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForKubernetesClusterAws>): ServiceAccountCredentialsBaseForKubernetesClusterAws {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForKubernetesClusterAws(), model);
        ServiceAccountCredentialsBaseForKubernetesClusterAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForKubernetesClusterAws>): ServiceAccountCredentialsBaseForKubernetesClusterAws {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForKubernetesClusterAws.newInstance(<ServiceAccountCredentialsBaseForKubernetesClusterAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForKubernetesClusterAws) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForKubernetesClusterAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForKubernetesClusterAws): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesCluster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForKubernetesClusterAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
